import type { IAuthUser } from '@/shared/types/auth-user'
import { getPermissions } from './permissions'
import type { AppAbility } from './permissions'
import { AbilityBuilder, createMongoAbility } from '@casl/ability'

/**
 * What the organization registry says about the caller's organization. Unknown
 * (still loading, or the lookup failed) restricts nothing — the backend still
 * answers with its own error then.
 */
export interface IOrganizationTraits {
  isBloodCenter?: boolean
}

export function defineAbilitiesFor(
  user: IAuthUser | null,
  organization: IOrganizationTraits = {},
): AppAbility {
  const { can, cannot, rules } = new AbilityBuilder<AppAbility>(
    createMongoAbility,
  )

  if (!user) return createMongoAbility<AppAbility>(rules)

  // The landing page must open for any signed-in user, even one whose roles
  // grant nothing else — otherwise `/` would bounce them to /forbidden.
  can('read', 'home')

  user.roles.forEach((role) => {
    getPermissions(role).forEach((permission) => {
      can(permission.action, permission.subject)
    })
  })

  // «Склад и хранение компонентов» is a medical institution's — a blood
  // station keeps its components in Экспедиция and gets 422 `100166` here,
  // whatever its roles (BS-295).
  if (organization.isBloodCenter) cannot('read', 'warehouse-stock')

  return createMongoAbility<AppAbility>(rules)
}

export const ability = (user: IAuthUser | null) => defineAbilitiesFor(user)
